<template>
	<transition name="fade">
		<!-- Content -->
		<Content 
			title="Payroll Management"
			@create="create"
			@download="download"
			createText="New Payroll"
		>

			<!-- Table -->
				<c-table
					ref="myTable"
					:items="items" 
					:fields="fields" 
					:per-page="15" 
					:total="items ? items.length : 0"
					:isBusy="isLoading"

					hover striped bordered small fixed 

					@editItem="edit"
					@deleteItem="confirmDelete"
					@payrollDetail="payrollDetail"
					@payrollSummary="payrollSummary"
					sortBy="ClientName"
				
				/>

			<!-- Form -->
			<Form ref="myForm" />


		</Content>
	</transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Content from "../components/Content";
import cTable from '../../base/PayrollTable';
import Form from './components/PayrollForm';


const fields = [
				{
					label: "Client/Employee",
					key: "ClientName",
					sortable: true
				},
				{
					label: "Branch",
					key: "ClientBranchName",
					sortable: true
				},
				{
					label: "Year",
					key: "Year",
					sortable: true,
					class:"text-center"
				},
				{
					label: "Month",
					key: "MonthName",
					sortable: true
				},
				{
					label: "Period",
					key: "Period",
					sortable: true,
					class: 'text-center'
				},
				{
					label: "Type",
					key: "PayrollType",
					sortable: true,
					class: 'text-center'
				},
				{
					label: "Description",
					key: "Description",
					sortable: true
				},
				{
					label: "Transaction Date",
					key: "TransactionDate",
					sortable: true,
					class: "text-center"
				},
				{
					label: "Status",
					key: "Status",
					sortable: true,
					class: 'text-center'
				},
				{
					key: "actions",
					class: "text-center"
				}
];

export default {
	name: 'PayrollManagement',
	components:{
		Content,
		cTable,
		Form
	},
	data(){
		return {	
			fields: fields,
			isLoading: true,
		}
	},
	methods:{
		...mapActions(
			{
				index:'getPayrolls',
				cancel: 'archivePayroll' 
			},
		),
		create(){
			this.$refs.myForm.create();
		},
		edit(item){
			this.$refs.myForm.edit(item);
		},
		download(){
			alert('download');
		},
		payrollDetail(data){
			this.$router.push('/payroll/payroll-detail/' + data.item.PayrollCutOffID )
		},
		payrollSummary(data){
			this.$router.push('/payroll/payroll-summary/' + data.item.PayrollCutOffID )
		},
		confirmDelete(data){
			this.$swal({...this.response.cancel, text: `Do you really want to delete this payroll?`}).then(response => {
				if (response.value == true) {
					this.archive(data.item);
				}
			});
		},
		archive(item){
			this.cancel(item.PayrollCutOffID)
				.then(response => {
						this.$swal({...this.response.success });
				});
		},
		filter(){
			this.index(this.$refs.myTable.form);
		}
	},

	computed:{
		...mapGetters(
			{ items: 'payrolls', response: 'response'}
			)
	},
	mounted(){
		this.index(this.$refs.myTable.form)
			.then(response => {
				this.isLoading = false;
			})
	}
}
</script>